export const ArrowNextIcon: React.FC<React.SVGAttributes<{}>> = props => (
    <svg width="20" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M1.5 13L7.5 7L1.5 0.999999"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
